export default __webpack_public_path__ + "static/media/PowellCatLocation-11.28ce9b24.jpg";